 <template>
  <v-dialog v-model="show" width="30%">
    <v-card style="margin-top:20px">
      <v-card-text>{{$t('B0400.messages.modifyEta')}}</v-card-text>
      <v-card-actions>
        <v-btn @click="show=false" class="mr-3">{{$t('app.buttons.abolitionAndCancel')}}</v-btn>
        <v-btn @click="reset" class="mr-3">{{$t('app.buttons.reset')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  data() {
    return {
      show: false
    }
  },
  methods: {
    popup() {
      this.show = true
    },
    reset() {
      this.show = false
      this.$emit('reset')
    }
  }
}
</script>
